import request from '@/utils/request'

// 当前账户得菜单查询
// export const requestQueryMenu = () => { return request({url: '/menus/current', method: 'get'}).then(res => res.data); };

// 获取验证码 verification/code
export const getVerification = params => { return request({ url: '/verification/code/' + params, responseType: 'arraybuffer', method: 'get' }).then(res => res.data); };

// 账户查询
export const requestQueryUser = params => { return request({ url: '/users/query', method: 'post', data: params }).then(res => res.data); };
// 重置密码
export const resetUserPwd = params => { return request({ url: '/users/' + params.id + '/password', method: 'put', params: { newPassword: params.newPassword } }).then(res => res.data); };
// 删除账户
export const removeUser = params => { return request({ url: '/users/delete', method: 'put', data: params }).then(res => res.data); };
// 新增账户 addUser
export const addUser = params => { return request({ url: '/users/create', method: 'post', data: params }).then(res => res.data); };
// 账户启用
export const enableUser = params => { return request({ url: '/users/enabled', method: 'put', data: params }).then(res => res.data); };
// 账户停用
export const disableUser = params => { return request({ url: '/users/disabled', method: 'put', data: params }).then(res => res.data); };
// 查询账户的详情
export const getAccountDetails = params => { return request({ url: '/users/details/' + params, method: 'get' }).then(res => res.data); };
// 编辑账户
export const updateAccount = params => { return request({ url: '/users/update', method: 'post', data: params }).then(res => res.data); };
// 修改密码
export const updateUserPwd = params => { return request({ url: '/users/password/update', method: 'post', data: params }).then(res => res.data); };


// 获取服务项目的下拉列表
export const requestQueryServiceValue = params => { return request({ url: '/source/service/list/' + params, method: 'get' }).then(res => res.data); };
// 获取机构列表 /source/child/list/select
export const getSourceList = () => { return request({ url: '/source/query/all', method: 'get' }).then(res => res.data); };
// 查询机构
export const getSourceQuery = params => { return request({ url: '/source/query', method: 'post', data: params }).then(res => res.data); };
// 机构启用
export const enableSource = params => { return request({ url: '/source/enabled', method: 'put', data: params }).then(res => res.data); };
// 机构失效
export const disableSource = params => { return request({ url: '/source/disabled', method: 'put', data: params }).then(res => res.data); };
// 新增机构
export const addSource = params => { return request({ url: '/source/create', method: 'post', data: params }).then(res => res.data); };
// 编辑机构
export const updateSource = params => { return request({ url: '/source/update', method: 'put', data: params }).then(res => res.data); };

// 根据网点查城市
export const getCityByBranch = params => { return request({ url: '/branches/cities/' + params, method: 'get' }).then(res => res.data); };
// 所有权限 /roles/all/query
export const requestQueryRoleList = () => { return request({ url: '/roles/all/query', method: 'post' }).then(res => res.data); };

// 订单查询
export const requestQueryOrder = params => { return request({ url: '/order/query', method: 'post', data: params }).then(res => res.data); };
// 导出订单
export const exportOrderList = params => { return request({ url: '/order/export', method: 'post', data: params, responseType: 'blob' }).then(res => res.data); };
// 导出订单信息
export const exportOrderDataExl = params => { return request({ url: '/order/plus/export/order', method: 'post', data: params, responseType: 'blob' }).then(res => res.data); };
//加载全部订单状态
export const loadOrderStatus = () => { return request({ url: '/order/status', method: 'get' }).then(res => res.data); }

// 根据账户查询对应的机构权限
export const queryOrgByAccount = () => { return request({ url: '/users/bind/sources', method: 'get' }).then(res => res.data); };
// 根据账户所选择的机构查询该账户拥有的省份权限 users/bind/province/
export const queryProvinceByAccountAndOrg = params => { return request({ url: '/users/bind/province/' + params, method: 'get' }).then(res => res.data); };

// 根据账户所选择的机构以及省份查询当前账户所拥有的城市权限
export const queryCityByAccountAndOrg = params => { return request({ url: '/users/bind/cities/' + params.sourceCode + '/' + params.proCode, method: 'get' }).then(res => res.data); };

// 根据账户所选择的机构查询该账户拥有的区权限 users/bind/area
export const queryAreaByAccountAndOrg = params => { return request({ url: '/users/bind/area', method: 'post', data: params }).then(res => res.data); };

// 导出网点数据
export const exportNetworkData = params => { return request({ url: '/branches/export', method: 'post', data: params, responseType: 'blob' }).then(res => res.data); };


// 查询网点
export const getNetQuery = params => { return request({ url: '/branches/query', method: 'post', data: params }).then(res => res.data); };

// 获取服务状态
export const getServiceQuery = params => { return request({ url: '/source/service/query', method: 'post', data: params }).then(res => res.data); };
// 获取服务状态详情
export const queryServiceQueryByCode = params => { return request({ url: '/source/service/details/' + params, method: 'get' }).then(res => res.data); };
// 保存编辑的服务状态
export const saveServiceSts = params => { return request({ url: '/source/service/bind/order/status', method: 'post', data: params }).then(res => res.data); };
// 根据服务显示状态
export const queryStsQueryByService = params => { return request({ url: '/order/status/' + params, method: 'get' }).then(res => res.data); };
// 订单中心
// 查询城市列表
export const queryCityList = params => { return request({ url: 'region/query/bind/city/user', method: 'get' }).then(res => res.data); };
// 查询机构列表
export const queryOrgListByCity = params => { return request({ url: '/source/query/city', method: 'post',data: params }).then(res => res.data); };
// 查询订单中心列表
export const queryOrderCenterList = params => { return request({ url: '/order/plus/v2/query', method: 'post', data: params }).then(res => res.data); };
// 查询订单详情
export const queryOrderDetails = params => { return request({ url: '/order/plus/detail', method: 'get', params: params}).then(res => res.data); };
// 查询供应商
export const querySuppliers = params => { return request({ url: '/supplier/query', method: 'get', params: params}).then(res => res.data); };
// 查询全部供应商
export const queryAllSuppliers = () => { return request({ url: '/supplier/queryByAll', method: 'get'}).then(res => res.data); };
export const queryAllSuppliersByCity = params => { return request({ url: '/supplier/queryByAll/cityCode', method: 'get', params: params}).then(res => res.data); };
export const queryAllSuppliers2 = params => { return request({ url: '/supplier/query2', method: 'get', params: params}).then(res => res.data); };
// 查询供应商列表
export const querySupplierList = params => { return request({ url: '/supplier/list', method: 'post', data: params}).then(res => res.data); };
// 供应商管理
export const manageSupplier = (operater, params) => { return request({ url: `/supplier/${operater}`, method: 'post', data: params}).then(res => res.data); };
// 查询司机列表
export const queryDriverList = params => { return request({ url: '/supplierDriver/query', method: 'get', params: params}).then(res => res.data); };
// 查询门店列表
export const queryStoreList = params => { return request({ url: '/supplierStore/query', method: 'get', params: params}).then(res => res.data); };
// 更新订单状态
export const updateOrderStatus = params => { return request({ url: '/order/plus/update', method: 'post', data: params }).then(res => res.data); };
// 订单预导入
export const uploadExcelFile = params => { return request({ url: '/order/upload', method: 'post', headers: { 'Content-Type': 'multipart/form-data'}, data: params }).then(res => res.data); };
// 订单导入-查询上传验证后的数据列表
export const requestOrderImportedList = params => { return request({ url: '/order/verify/query', method: 'post', data: params }).then(res => res.data); };
// 订单导入-导出校验后的数据列表
export const exportVerifyOrderData = params => { return request({ url: '/order/verify/export', method: 'post', data: params, responseType: 'blob' }).then(res => res.data); };
// 订单导入-确认导入验证后的数据
export const importOrderData = params => { return request({ url: '/order/import', method: 'get', params: params}).then(res => res.data); };
// <--服务包导入-->
// 上传文件
export const uploadServicePacksFileReq = (reqUrl, fileData) => { return request({ url: reqUrl, method: 'post', headers: { 'Content-Type': 'multipart/form-data'}, data: fileData }).then(res => res.data); };
// 列表查询
export const queryServicePacksImportList = (reqUrl, params) => { return request({ url: reqUrl, method: 'get', params: params }).then(res => res.data); };
// 导出数据清单
export const exportVerifyServiceDataFile = params => { return request({ url: '/data/export', method: 'get', params: params, responseType: 'blob' }).then(res => res.data); };
// 提交数据清单
export const submitServiceDataList = params => { return request({ url: '/data/submit', method: 'get', params: params}).then(res => res.data); };
// 查询所有城市
export const queryAllCityList = () => { return request({ url: '/region/query/all', method: 'get' }).then(res => res.data); };
// 查询是否具有全国城市权限
export const queryCityAllPermiss = () => { return request({ url: '/region/query/bind/city/all', method: 'get' }).then(res => res.data); };

//保存投诉信息
export const saveComplaintInfo = params => { return request({ url: '/order/plus/updateComplaintSituation', method: 'post', data: params }).then(res => res.data); }

//查询供应商或者机构城市
export const queryCityByCode = params => { return request({ url: '/region/query/code', method: 'get', params: params}).then(res=>res.data); }

//删除供应商价格
export const deleteSupplierPrice = params => { return request({ url: '/supplier/service/price/delete', method: 'post', data: params}).then(res=>res.data); }

//删除机构价格
export const deleteSourcePrice = params => { return request({ url: '/source/service/price/delete', method: 'post', data: params}).then(res=>res.data); }

//核销中心
export const queryListByEquityCode = params => { return request({ url: '/equity/list/query', method: 'post', data: params}).then(res=>res.data); }

// 券码激活
// 上传Excel并校验
export const equityUploadFile = params => { return request({ url: '/equity/upload', method: 'post', headers: { 'Content-Type': 'multipart/form-data'}, data: params }).then(res => res.data); };
// 确定导入券码数据
export const importEquity = params => { return request({ url: '/equity/import/confirm', method: 'post', data: params}).then(res => res.data); };
// 导出Excel校验后的券码
export const exportEquity = params => { return request({ url: '/equity/verify/export', method: 'post', data: params, responseType: 'blob' }).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/api.js